import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    try {
      (window as any).__lastReactError = {
        message: error.message,
        stack: error.stack,
        componentStack: info.componentStack,
      };
      sessionStorage.setItem(
        "__lastReactError",
        JSON.stringify({
          message: error.message,
          stack: (error.stack || "").slice(0, 4000),
          componentStack: (info.componentStack || "").slice(0, 4000),
        })
      );
    } catch {}
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            fontFamily: "sans-serif",
            backgroundColor: "#f7f7f7",
            color: "#222",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: 22, marginBottom: 12 }}>
            Etwas ist schiefgelaufen
          </h1>
          <p style={{ marginBottom: 20, maxWidth: 480 }}>
            Beim Laden der App ist ein unerwarteter Fehler aufgetreten. Bitte
            versuche, die Seite neu zu laden.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              backgroundColor: "#005e34",
              color: "white",
              border: "none",
              borderRadius: 4,
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            Neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
